
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import ContentSection from "../../models/ContentSection";

@Component
export default class ContentCard extends Vue {
  @Prop()
  onDelete?: (index: number) => void;

  @Prop()
  onEdit?: (index: number) => void;

  @Prop()
  contentIndex!: number;

  @Prop()
  fixed!: boolean;

  @Prop()
  handle!: boolean;

  @Ref()
  slotWrapper!: HTMLDivElement

  private isMission = false;

  mounted() {
    if((this.$refs.slotWrapper as HTMLElement).innerHTML.includes("Philosophy")){
      this.isMission = true;
    }
  }

  deletedClicked(index: number) {
    if (this.onDelete) {
      this.onDelete(this.contentIndex);
    }
  }
  editClicked(index: number) {
    if (this.onEdit) {
      this.onEdit(this.contentIndex);
    }
  }
}
